__turbopack_context__.v({
  "bg": "MasterYourMetabolism-module__MAymCa__bg",
  "content": "MasterYourMetabolism-module__MAymCa__content",
  "description": "MasterYourMetabolism-module__MAymCa__description",
  "featureCard": "MasterYourMetabolism-module__MAymCa__featureCard",
  "features": "MasterYourMetabolism-module__MAymCa__features",
  "full-size": "MasterYourMetabolism-module__MAymCa__full-size",
  "img-wrapper": "MasterYourMetabolism-module__MAymCa__img-wrapper",
  "root": "MasterYourMetabolism-module__MAymCa__root",
  "video": "MasterYourMetabolism-module__MAymCa__video",
  "video-content": "MasterYourMetabolism-module__MAymCa__video-content",
  "videoRoot": "MasterYourMetabolism-module__MAymCa__videoRoot",
});
